import { Category } from '@/api/models';

export const categories: Category[] = [
  {
    id: 1,
    name: 'Engineering & Technology 🔧',
    description: 'Technical assistants for design, process technologies, product engineering, standards compliance, and R&D support.'
  },
  {
    id: 2,
    name: 'Projects & Operations ⚙️',
    description: 'Tools for project delivery, execution support, operational troubleshooting, reporting and lessons-learned management.'
  },
  {
    id: 3,
    name: 'Commercial & Sales 💼',
    description: 'Customer-facing and commercial enablement assistants for sales, CPQ, marketing, product management and bid support.'
  },
  {
    id: 4,
    name: 'Global Support Functions 🏢',
    description: 'Governance and support tools covering HR, legal, finance, procurement, compliance, regulatory and InfoSec guidance.'
  },
];